const useNavigationType = (edges) => {
  let investor
  let product
  for (const node in edges) {
    if (edges[node].node.type === 'Investor' && investor === undefined) {
      investor = edges[node].node
    } else if (edges[node].node.type === 'Product' && product === undefined) {
      product = edges[node].node
    }
  }
  return [investor, product]
}

export default useNavigationType
